import { render, staticRenderFns } from "./CanvasShortcutDialog.vue?vue&type=template&id=06d49655&"
import script from "./CanvasShortcutDialog.vue?vue&type=script&lang=js&"
export * from "./CanvasShortcutDialog.vue?vue&type=script&lang=js&"
import style0 from "./CanvasShortcutDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports